<template>
  <div class="hr_root_div">
    <div id="page-header">
      <div class="bluebar head_logo"></div>
      <div>
        {{ $t("message")["HealthHome.hr"] }}&nbsp;&nbsp;&nbsp;&nbsp;{{
          data_date
        }}
      </div>
      <div style="margin-left: auto">
        <a-button style="margin-right: 15px" @click="exportToCSV">{{
          $t("message")["Export.button.name"]
        }}</a-button>
        <a-date-picker
          id="date_picker"
          @change="ChangeDataDate"
        ></a-date-picker>
      </div>
    </div>
    <div id="hr_content_area">
      <HeartRateChart
        id="heartrate-chart"
        :hr-list="this.hrList"
        :sport-list="this.sportList"
        :sleep="this.sleep"
        :change="this.change"
      ></HeartRateChart>
      <HeartRateNomalData
        id="heartrate-normal-data"
        :max-hr="this.maxHr"
        :min-hr="this.minHr"
        :avg-hr="this.avgHr"
      ></HeartRateNomalData>
      <HeartRateSportAnalyzeData
        id="heartrate-sport-data"
        :minutes-list="minutesList"
        :abnormal-hr-list="abnormalHrList"
      ></HeartRateSportAnalyzeData>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import HeartRateChart from "../../components/heartrate/HeartRateChart.vue";
/* eslint-disable */
import HeartRateNomalData from "../../components/heartrate/HeartRateNomalData.vue";
/* eslint-disable */
import HeartRateSportAnalyzeData from "../../components/heartrate/HeartRateSportAnalyze.vue";
import domain from "../../domain";
import request from "../../utils/request";

export default {
    props: ['userData'],
    components: {
        HeartRateChart,
        HeartRateNomalData,
        HeartRateSportAnalyzeData,
    },
    data() {
        return {
            data_date:"",
            deviceid:"",
            device_type: 1,
            uid: "",            
            hrList:[ ],
            sportList:[ ],
            sleep:{},
            maxHr:0,
            minHr:0,
            avgHr:0,
            abnormalHrList: [
            //{value: 168, name: "", time: '09:20', key: 1},
            //{value: 172, name: "", time: '09:31', key: 2}
            ],
            abHrTotalList: [],
            minutesList:[0, 0, 0, 0, 0],
            avgSportHr:0,
            maxPercent:0,
            change:0,
            UserMaxHR:0,
            oneDetailList:[]
        };
    },
    methods: {
        exportToCSV(){
          // console.log(this.oneDetailList)
          const exHr =[]
          for(let i=0;i<this.oneDetailList.length;i++){
            if(this.oneDetailList[i]>30 && this.oneDetailList[i]<210){
              const oneHr = {
                time: Math.floor(i/60) + ":" + i%60,
                value: this.oneDetailList[i]
              }
              exHr.push(oneHr)
            }
          }
          const msg = this.$t("message")
          const nickName = sessionStorage.getItem("nickname");
          let csvData = `${msg['Export.Base.title']}\n`; // 第一行
          csvData += `${msg['Export.Base.nickname']},${nickName},${msg['Export.Base.deviceId']},\'${this.deviceid},${msg['Export.Base.date']},${this.data_date}\n`  //第二行
          csvData += `\n${msg['Export.Base.details']}\n`  //第三行
          csvData += `${msg['Export.Base.times']},${msg['Export.Heart.hr']}\n`  //第四行
          exHr.forEach((item) => {
            csvData += `${item.time},${item.value}\n`; // 数据行
          });

          //csv
          const csvFileName = `${nickName}_${this.deviceid}_HeartRate_${this.data_date}.csv`
          const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
          // 创建一个指向Blob对象的URL
          const url = window.URL.createObjectURL(blob);
          // 创建一个隐藏的<a>元素并模拟点击以触发下载
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', csvFileName); // 设置下载文件名
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); // 清理
        },

        fetchHRData(deviceid,data_date) {
            let age = 25;
            if (age<20) {
                this.UserMaxHR = 200;
            } else if (age > 120) {
                this.UserMaxHR = 220 - 25;
            } else {
                this.UserMaxHR = 220-age;
            }
            let reqParams = {
                device_id: deviceid,
                record_date: data_date,
                age: age
            };
            let reqUrl = domain.URLS.hrDetailDataUrl;
            if(this.device_type==2){
                reqParams = {
                    uid: this.uid,
                    record_date: data_date,
                    age: age
                };
                reqUrl = domain.URLS.hrBleDetailDataUrl;
            }

            let that = this;
            request({
                url: reqUrl,
                methods: "GET",
                params: reqParams
            }).then(function(response) {
                if (response != null) {
                    if (response.data.ReturnCode == 0) {
                        that.resetData(response.data.Data);
                    }
                }
            });
        },

        resetData (data) {

            var detail = data.AvgHrDetail
            var tempHR = 0
            var tempIndex = 0
            var maxHR = 0
            var minHR = -1
            var totalHR = 0
            var count = 0
            var avgHR = 0
            var abHrList = []
            var abIndex = 0
            this.oneDetailList = detail
            for (var i = 0; i < detail.length; i++) {
                var hr = detail[i]
                var index = parseInt(i/10)
                if (index != tempIndex) {
                    tempHR = 0
                    tempIndex = index
                }
                if (hr > tempHR) {
                    tempHR = hr
                }
                if (tempHR > 0) {
                    this.hrList[index] = tempHR
                } else {
                    this.hrList[index] = null
                }
                if (hr <= 0) {
                    continue
                }
                if (hr > this.UserMaxHR || hr < 35) {
                    var hour = (Math.floor(i / 60 ) >= 10) ? "" + Math.floor(i / 60 ) : "0"+Math.floor(i / 60 )
                    var minute = (i % 60 >= 10) ? "" + i % 60 : "0" + i % 60
                    var tStr = hour + ":" + minute
                    abIndex = abHrList.length
                    var abHr = {value: hr, name: "", time: tStr, key: abIndex+1}
                    abHrList.push(abHr)
                }
                if (maxHR < hr) {
                    maxHR = hr
                }
                if (minHR < 0 || minHR > hr) {
                    minHR = hr
                }
                totalHR = totalHR + hr
                count++
            }
            if (count > 0) {
                avgHR = totalHR / count
            }

            var totalList = []
            var currList = []
            for (var i = 0; i < abHrList.length; i++) {
                currList.push(abHrList[i]);
                if((i != 0 && (i + 1) % 3 == 0) || i == abHrList.length-1) {
                    totalList.push(currList);
                    currList = [];
                }
            }

            this.change = this.change+1

            this.avgHr = parseInt(data.HeartRate.AvgHr)
            this.maxHr = parseInt(data.HeartRate.MaxHr)
            this.minHr = parseInt(data.HeartRate.MinHr)
            this.abHrTotalList = totalList
            if (totalList.length > 0) {
                this.abnormalHrList = totalList[0];
            }
            this.minutesList = [
                data.SportHR.Regular>0?data.SportHR.Regular:0,
                data.SportHR.Warm_up>0?data.SportHR.Warm_up:0,
                data.SportHR.Fat_burning>0?data.SportHR.Fat_burning:0,
                data.SportHR.Aerobic>0?data.SportHR.Aerobic:0,
                data.SportHR.Anaerobic>0?data.SportHR.Anaerobic:0,
                data.SportHR.Extreme>0?data.SportHR.Extreme:0]
            this.avgSportHr = parseInt(data.SportHR.AvgSportHR)
            this.maxPercent = parseInt(this.avgSportHr * 100 / this.UserMaxHR)
        },

        handleCurrentChange(val) {
            this.abnormalHrList = this.abHrTotalList[val-1];
        },

        ChangeDataDate(val){
            let date_str = val.format('YYYY-MM-DD');
            this.data_date = date_str;
            this.fetchHRData(this.deviceid,this.data_date);
        }
    },
    mounted: function () {
        this.device_type = sessionStorage.getItem("device_type");
        this.deviceid = sessionStorage.getItem("deviceid");
        if(this.device_type==2){
            this.uid = sessionStorage.getItem("uid");
        }

        this.data_date = this.$route.params.data_date;
      console.log("传过来的日期是L: "+this.data_date)
        this.fetchHRData(this.deviceid,this.data_date);
    }
}

</script>

<style scoped lang="scss">
@import "../style/GlobalStyle.scss";
.hr_root_div {
    padding-bottom: 10px;
    position: relative;
    left: 0px;
    border: 1px solid white;
}

#page-header {
    height: 50px;
    font-size: 16px;
    color: #292929;
    letter-spacing: 0;
    line-height: 30px;
    font-weight: bold;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding-left: 15px;
    padding-right: 15px;
}

.bluebar {
    width: 4px;
    height: 13px;
    background-color: #2284FF;
}

.head_logo {
    margin-right: 10px;
}

#date_picker {
    margin-left: auto;
}

#hr_content_area {
    width: 100%;
    height: 750px;
}

#heartrate-chart {
    box-sizing:border-box;
    width: 100%;
}

#heartrate-normal-data {
    box-sizing:border-box;
  margin-top: 30px;
}

#heartrate-sport-data {
    box-sizing:border-box;
}

</style>
